import { useCallback } from 'react';
import LogRocket from 'logrocket';

import { SUBSCRIPTION_CHURN_WIN_BACK } from '../../../../../../constants/analytics-events';

import { Segment } from '../../../../../../services/analytics-services/segment';

export const CHURN_WIN_BACK_ACTIONS = {
  DISPLAYED_COUPON: 'CHURN_WIN_BACK_DISPLAYED_COUPON',
  COUPON_APPLIED: 'CHURN_WIN_BACK_COUPON_APPLIED',
  ERROR: 'CHURN_WIN_BACK_ERROR',
};

const logRocketEventName = 'SUBSCRIPTION_CHURN_WIN_BACK';

export const useTrackChurnWinBackAction = (action, payload) => {
  return useCallback(
    (error) => {
      const trackEvent = () => {
        if (action === CHURN_WIN_BACK_ACTIONS.COUPON_APPLIED) {
          const environment = process.env.NODE_ENV || 'development'; // "development" or "production"
          LogRocket.track(logRocketEventName, {
            env: environment,
          });
        }
        Segment.trackEvent(action, {
          parentAction: SUBSCRIPTION_CHURN_WIN_BACK,
          error,
          status: payload.status,
          couponCode: payload.coupon,
        });
      };
      setTimeout(trackEvent, 0);
    },
    [action, payload],
  );
};
